import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// صفحات عامة للأطراف الخارجية (مثل تأكيد المورّد) لا تُعرض لها شاشة البداية.
const PUBLIC_PREFIXES = ["/purchase-confirm/", "/verify/"];

// Branded launch screen shown once per app start (PWA cold start included).
export const SplashScreen = () => {
  const { t } = useTranslation();
  const external = PUBLIC_PREFIXES.some((path) => window.location.pathname.startsWith(path));
  const [gone, setGone] = useState(external || sessionStorage.getItem("splash_shown") === "1");
  const [fading, setFading] = useState(false);

  useEffect(() => {
    if (gone) return undefined;
    const fade = setTimeout(() => setFading(true), 1100);
    const hide = setTimeout(() => {
      sessionStorage.setItem("splash_shown", "1");
      setGone(true);
    }, 1600);
    return () => {
      clearTimeout(fade);
      clearTimeout(hide);
    };
  }, [gone]);

  if (gone) return null;

  return (
    <div
      data-testid="splash-screen"
      style={{ backgroundColor: "#12161C" }}
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center transition-opacity duration-500 ${
        fading ? "opacity-0" : "opacity-100"
      }`}
    >
      <img src="/icon-192.png" alt="HELCOO" className="h-24 w-24 animate-pop rounded-3xl" />
      <p className="mt-6 font-brand text-4xl font-black tracking-tight text-white">{t("app.name")}</p>
      <span className="mt-4 h-1 w-24 rounded-full bg-primary" />
    </div>
  );
};
